import React from 'react';
import { Routes, Route, Navigate, NavLink, useLocation } from 'react-router-dom';
import { Sidebar } from '../../components/settings/Sidebar';
import ChangePassword from '../ChangePassword';
import AISettings from './AISettings';
import CalendlySettings from './CalendlySettings';
import ChatbotLimitsSettings from './ChatbotLimitsSettings';
import DesignSettings from './DesignSettings';
import GallerySettings from './GallerySettings';
import GeneralSettings from './GeneralSettings';
import MiniAppsSettings from './MiniAppsSettings';
import MultilingualSettings from './MultilingualSettings';
import OrderTrackingSettings from './OrderTrackingSettings';
import ProductsSettings from './ProductsSettings';
import ProfilesSettings from './ProfilesSettings';
import RealEstateSettings from './RealEstateSettings';
import ServicesSettings from './ServicesSettings';
import VideosSettings from './VideosSettings';
import WidgetSettings from './WidgetSettings';
import SocialMediaSettings from './SocialMediaSettings';
import IntegrationsLayout from './integrations/Layout';
import { useSidebar } from '../../hooks/useSidebar';
import { useMediaQuery } from '../../hooks/useMediaQuery';

export default function SettingsLayout() {
  const location = useLocation();
  const { isOpen } = useSidebar();
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const isFullWidthPage = location.pathname === '/app/settings/general' || 
                         location.pathname === '/app/settings/profiles' ||
                         location.pathname === '/app/settings/change-password';

  return (
    <div className="flex h-[calc(100vh-4rem)] overflow-hidden">
      {!isFullWidthPage && !isMobile && (
        <div className={`transition-all duration-500 ease-in-out ${isOpen ? 'w-64' : 'w-20'} flex-shrink-0 border-r border-white/10`}>
          <Sidebar />
        </div>
      )}
      <div className="flex-1 overflow-y-auto">
        <div className="p-8">
          <Routes>
            <Route path="/" element={<Navigate to="general" replace />} />
            <Route path="general" element={<GeneralSettings />} />
            <Route path="ai" element={<AISettings />} />
            <Route path="multilingual" element={<MultilingualSettings />} />
            <Route path="design" element={<DesignSettings />} />
            <Route path="widget" element={<WidgetSettings />} />
            <Route path="mini-apps" element={<MiniAppsSettings />} />
            <Route path="calendar" element={<CalendlySettings />} />
            <Route path="products" element={<ProductsSettings />} />
            <Route path="order-tracking" element={<OrderTrackingSettings />} />
            <Route path="services" element={<ServicesSettings />} />
            <Route path="videos" element={<VideosSettings />} />
            <Route path="gallery" element={<GallerySettings />} />
            <Route path="realestate" element={<RealEstateSettings />} />
            <Route path="social" element={<SocialMediaSettings />} />
            <Route path="profiles" element={<ProfilesSettings />} />
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="limits" element={<ChatbotLimitsSettings />} />
            <Route path="integrations/*" element={<IntegrationsLayout />} />
            <Route path="*" element={<Navigate to="general" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}